export function AppBuildMode(n) {
  if (n == "PRODUCTION") {
    return {
      API: "https://backend-api.psikku.com",
      DEV: false,
      URLWS: "wss://backend-api.psikku.com/websocket",
      API_PDULI: "https://backend-pduli.psikku.com",
    };
  } else {
    return {
      // API: "http://10.0.0.8:8081",
      API: "https://hopeful-keen-shark.ngrok-free.app/platform",
      API_PDULI: "https://vp73q4fr-3000.asse.devtunnels.ms",
      // API_PDULI: "https://a86a-110-139-228-197.ngrok-free.app",

      DEV: true,
      // URLWS: "ws://10.0.0.8:8081/websocket",
      URLWS: "wss://hopeful-keen-shark.ngrok-free.app/platform/websocket",
    };
  }
}
